<template>
  <div class="row employergroup-card">
    <div class="employergroup-wrap">
      <form @submit.prevent="searchEmployerGroup">
        <div class="form-group row">
          <input-text
            labelFor="group_code"
            labelName="Group Name"
            :vmodel.sync="filters.group_name"
            formGroupClass="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
            inputClass="employergroupsearch-field"
          />
          <input-text
            labelFor="group_code"
            labelName="Group Code"
            :vmodel.sync="filters.group_code"
            formGroupClass="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
            inputClass="employergroupsearch-field"
          />

          <input-text
            labelFor="group_email"
            labelName="Email"
            :vmodel.sync="filters.group_email"
            formGroupClass="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
            inputClass="employergroupsearch-field"
          />
          <input-multi-select
            labelFor="status"
            labelName="Status"
            inputName="status"
            :vmodel.sync="filters.status"
            :options="statuses.map((type) => type.value)"
            :custom-label="(opt) => statuses.find((x) => x.value == opt).text"
            formGroupClass="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
            placeholder="Select Status"
          />
        </div>

        <div class="form-group row">
          <input-multi-select
            labelFor="state"
            labelName="State"
            inputName="state"
            :vmodel.sync="filters.state"
            :options="states.map((type) => type.value)"
            :custom-label="(opt) => states.find((x) => x.value == opt).text"
            formGroupClass="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
            placeholder="Select State"
          />

          <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
            <label>Enrollment Date</label>
            <div class="enrollmentDate-picker">
              <date-picker
                @input="setToDate"
                input-class="employergroupsearch-field"
                placeholder="From"
                type="date"
                v-model="filters.signup_date_from"
                value-type="format"
                :disabled-date="
                  (date) => {
                    return disabledAfterCurrentDate(date, 'start');
                  }
                "
              ></date-picker>

              <date-picker
                input-class="employergroupsearch-field"
                placeholder="To"
                type="date"
                v-model="filters.signup_date_to"
                value-type="format"
                :disabled="disableDate"
                :disabled-date="
                  (date) => {
                    return disabledAfterCurrentDate(date, 'end');
                  }
                "
              ></date-picker>
            </div>
          </div>

          <input-multi-select
            labelFor="industry"
            labelName="Industry"
            inputName="industry"
            :vmodel.sync="filters.industry"
            :options="groupIndustries.map((type) => type.value)"
            :custom-label="
              (opt) => groupIndustries.find((x) => x.value == opt).title
            "
            formGroupClass="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
            placeholder="Select Industry"
          />

          <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
            <label>View Downline Clients For</label>
            <multiselect
              name="rep"
              v-model="filters.agent_id"
              placeholder="Select Rep"
              :options="reps.map((type) => type.id)"
              :custom-label="
                  (opt) => reps.find((x) => x.id == opt).first_name+' '+reps.find((x) => x.id == opt).last_name
                "
              :options-limit="100"
              :internal-search="false"
              :local-search="false"
              @search-change="searchHandler"
              @open="getReps"
            />
          </div>
           <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6">
            <label>Employers & Groups</label>
            <select class="form-select shadow-none" v-model="filters.type">
              <option value="">All</option>
              <option value="direct">Direct</option>
              <option value="downline">Downline</option>
            </select>
          </div>

          <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6">
            <label>Group Type</label>
            <select class="form-select shadow-none" v-model="filters.group_type">
              <option value="">All</option>
              <option value="callcenter">Call Center</option>
              <option value="employer">Employer</option>
              <option value="agency">Agency</option>
              <option value="group">Group</option>
            </select>
          </div>
          <!-- Routing Number Filter -->
          <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
            <label>Routing Number</label>
            <input
              v-model="filters.routing_number"
              type="text"
              class="employergroupsearch-field"
              placeholder="Routing Number"
              maxlength="9"
              pattern="\d{9}"
              @input="filters.routing_number = filters.routing_number.replace(/\D/g, '').slice(0, 9)"
            />
            <small v-if="filters.routing_number && filters.routing_number.length !== 9" style="color:red">
              Please enter exactly 9 digits.
            </small>
          </div>

          <!-- Bank Account Number Filter (Last 4 digits) -->
          <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
            <label>Bank Account Number (Last 4 digits)</label>
            <input
              v-model="filters.bank_account_last4"
              type="text"
              class="employergroupsearch-field"
              placeholder="Bank Account Number (Last 4 digits)"
              maxlength="4"
              pattern="\d{4}"
              @input="filters.bank_account_last4 = filters.bank_account_last4.replace(/\D/g, '').slice(0, 4)"
            />
            <small v-if="filters.bank_account_last4 && filters.bank_account_last4.length !== 4" style="color:red">
              Please enter exactly 4 digits.
            </small>
          </div>

          <!-- Account Name Filter -->
          <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
            <label>Account Name</label>
            <input
              v-model="filters.account_name"
              type="text"
              class="employergroupsearch-field"
              placeholder="Account Name"
            />
          </div>
          </div>
        <div class="row justify-content-md-end align-items-end">
          <!-- Quick Date Buttons -->
          <div class="col-12 col-xxl-auto col-xl-auto mb-3 mb-xl-0">
            <div class="quick-date-btns d-flex align-items-center gap-2 flex-wrap">
              <button
                type="button"
                class="quick-date-btn"
                :class="{ active: activeQuickFilter === 'all' }"
                @click="$emit('quick-filter', 'all')"
                title="All groups"
              >
                <i class="fas fa-list me-1"></i>
                All Groups
              </button>
              <button
                type="button"
                class="quick-date-btn"
                :class="{ active: activeQuickFilter === 'today' }"
                @click="$emit('quick-filter', 'today')"
                title="Groups signed up today"
              >
                <i class="fas fa-calendar-day me-1"></i>
                Groups Today
              </button>
              <button
                type="button"
                class="quick-date-btn"
                :class="{ active: activeQuickFilter === 'week' }"
                @click="$emit('quick-filter', 'week')"
                title="Groups signed up this week"
              >
                <i class="fas fa-calendar-week me-1"></i>
                Groups This Week
              </button>
              <button
                type="button"
                class="quick-date-btn"
                :class="{ active: activeQuickFilter === 'month' }"
                @click="$emit('quick-filter', 'month')"
                title="Groups signed up this month"
              >
                <i class="fas fa-calendar-alt me-1"></i>
                Groups This Month
              </button>
            </div>
          </div>
          <div class="col-xxl-2 col-xl-3">
            <button type="submit" class="univ-btn">Search</button>
          </div>
          <div class="col-xxl-2 col-xl-3">
            <button type="button" class="univ-btn" @click="exportGroup"><i class="fas fa-file-export" style="
    margin-right: 5px;
"></i> Export</button>
          </div>
          <div class="col-xxl-2 col-xl-3">
            <button type="button" class="univ-btn" @click="openLogModal">
              <img
                  src="@/assets/images/rep-logs.svg"
                  width="20px"
                  alt="Switch Logs Icon"
                  class="rep-logs-icon"
                />
                <span>Switch Logs</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import Api from "@/resource/Api";
import Helper from "@/resource/Helper";
export default {
  name: "EmployerGroupListSearch",
  props: {
    filters: {
      required: true,
      type: Object,
    },
    activeQuickFilter: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    disableDate: true,
    reps: [],
    states: Helper.getStates(),
    statuses: [
      { text: "ALL", value: " " },
      { text: "ACTIVE", value: "1" },
      { text: "INACTIVE", value: "0" },
    ],
    groupIndustries: [],
    isVipUser: false,
  }),
  methods: {
    searchHandler(query) {
      if (query.length > 2) {
        this.getReps(query);
      }
    },
    getGroupIndustries() {
      let url = "v2/get-employer-industry";
      Api.get(url)
        .then((res) => {
          this.groupIndustries = res.data.data;
        })
        .catch(() => {
          console.log("Something is wrong.");
        });
    },
    getReps(query = null) {
      let url;
      const baseUrl = `v2/get-rep-downline?size=100`;
      if (query) {
        url = `${baseUrl}&rep_name=${query}`;
      } else {
        url = baseUrl;
      }
      Api.get(url)
        .then((res) => {
          this.reps = res.data.data;
        })
        .catch(() => {
          console.log("Failed to fetch groups");
        });
    },
    searchEmployerGroup() {
      this.$emit("onSearch", this.filters);
    },
    disabledAfterCurrentDate(date, type) {
      const formattedDate = new Date(new Date().setHours(0, 0, 0, 0));
      if (type == "end") {
        if (
          date <
          new Date(new Date(this.filters.enrollment_from).setHours(0, 0, 0, 0))
        ) {
          return true;
        }
      }
      return (
        date >
        formattedDate.setDate(formattedDate.getDate() - +(type == "start"))
      );
    },
    setToDate(date) {
      if (date) {
        this.disableDate = false;
      } else {
        this.filters.enrollment_to = "";
        this.disableDate = true;
      }
    },
   async exportGroup() {
      let url;
      if (this.filters) {
        let filterUrl = Helper.objToUrlParams(this.filters);
        url = this.$endpoint.EXPORT_GROUP_LIST_FORMATTED + `?${filterUrl}`;
      } else {
        url = this.$endpoint.EXPORT_GROUP_LIST_FORMATTED;
      }
      let loader = this.$loading.show();
      await Api
        .get(url)
        .then((res) => {
           window.open(res.data.data.file_url, "_blank");
        })
        .finally(() => {
          loader.hide();
        });
    },
    openLogModal() {
      this.$emit("switchLogs");
    },
  },
  created(){
    this.isVipUser = this.$store.getters.vipUser;
    this.getGroupIndustries()
  }
};
</script>

<style scoped>
.form-select:focus{
  border-color:#03C3EC;
}
.quick-date-btns {
  gap: 6px;
}
.quick-date-btn {
  font-size: 13px;
  font-weight: 600;
  padding: 6px 14px;
  border-radius: 6px;
  border: 1.5px solid #d0d0d0;
  background-color: #f8f9fa;
  color: #444;
  cursor: pointer;
  transition: all 0.18s ease;
  white-space: nowrap;
  height: 36px;
  line-height: 1;
}
.quick-date-btn:hover {
  background-color: #e8f0fe;
  border-color: #4a6cf7;
  color: #4a6cf7;
}
.quick-date-btn.active {
  background-color: #4a6cf7;
  border-color: #4a6cf7;
  color: #fff;
  box-shadow: 0 2px 8px rgba(74, 108, 247, 0.22);
}
@media (max-width: 768px) {
  .quick-date-btn {
    font-size: 12px;
    padding: 5px 10px;
  }
}
</style>